<template>
    <tr class="tr__registers">
        <td class="available">
            <v-tooltip v-if="iamAvailabilityLabel" bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                    <span
                        class="availability-dot"
                        :class="iamAvailabilityClass"
                        v-bind="attrs"
                        v-on="on"
                    ></span>
                </template>
                <span>{{ iamAvailabilityLabel }}</span>
            </v-tooltip>
        </td>
        <td class="referencia">
            <v-text-field
                v-if="isIamWithoutSM && !isOe && !hasFluidMatch()"
                class="pr-2 input-without-sm"
                v-model="selectedIamPart.reference"
                outlined
                dense
                hide-details
                @change="handleChangeCombobox"
                :data-cy="`iam-livre-ref-${index}`"
            />
            <span v-else-if="selectedIamPart.freeIamPart">
                {{ selectedIamPart.reference }}
            </span>
            <span v-else-if="isPartsTruncate">
                {{ $globals.TRUNCATED_TEXT }}
            </span>
            <div
                class="d-flex flex-row"
                v-else-if="
                    isOe &&
                    (isEmptyReference(selectedPart.reference) ||
                        selectedPart.emptyReference)
                "
            >
                <v-text-field
                    class="pr-2 input-without-sm"
                    v-model="selectedPart.reference"
                    outlined
                    dense
                    hide-details
                    @change="handleChangeCombobox"
                    @keypress.enter="getPriceFromEucon"
                />
                <v-btn
                    fab
                    dark
                    elevation="0"
                    x-small
                    color="transparent"
                    hide-details
                    :style="
                        isEmptyReference(selectedPart.reference)
                            ? 'cursor: no-drop'
                            : 'cursor: pointer'
                    "
                    @click="getPriceFromEucon"
                >
                    <v-tooltip
                        color="black"
                        bottom
                        v-if="!isEmptyReference(selectedPart.reference)"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                :color="
                                    isEmptyReference(selectedPart.reference)
                                        ? '#D9D9D9'
                                        : '#F59534'
                                "
                                dark
                            >
                                mdi-magnify
                            </v-icon>
                        </template>
                        <span>
                            {{
                                $t(
                                    "module-budget.main-budget.parts.parts-row.price-oe-insert",
                                )
                            }}
                        </span>
                    </v-tooltip>
                    <v-icon
                        v-else
                        :color="
                            isEmptyReference(selectedPart.reference)
                                ? '#D9D9D9'
                                : '#F59534'
                        "
                        dark
                    >
                        mdi-magnify
                    </v-icon>
                </v-btn>
            </div>
            <span
                v-else-if="
                    typeof selectedPart.hasMatchVINOE === 'boolean' && isOe
                "
            >
                <v-tooltip color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-on="on"
                            v-bind="attrs"
                            small
                            class="mr-1"
                            :color="
                                selectedPart.hasMatchVINOE
                                    ? '#1e65d8'
                                    : '#d90b3b'
                            "
                        >
                            mdi-information
                        </v-icon>
                    </template>

                    <span>
                        {{
                            selectedPart.hasMatchVINOE
                                ? $t(
                                      "module-budget.main-budget.operations.operations-row.match-vinoe",
                                  )
                                : $t(
                                      "module-budget.main-budget.operations.operations-row.nomatch-vinoe",
                                  )
                        }}
                    </span>
                </v-tooltip>
                {{ selectedPart.reference }}
            </span>
            <span v-else>
                {{ isOe ? selectedPart.reference : selectedIamPart.reference }}
            </span>
        </td>
        <!-- :style="String(selectedIamPart.brand).length >= 14 ? 'vertical-align: middle !important;': ''" -->
        <td class="brand">
            <v-text-field
                v-if="isIamWithoutSM && !isOe && !hasFluidMatch()"
                class="pr-2 input-without-sm"
                v-model="selectedIamPart.brand"
                outlined
                dense
                hide-details
                @change="handleChangeCombobox"
                :data-cy="`iam-livre-brand-${index}`"
            />
            <span v-else>
                {{ isOe ? "" : selectedIamPart.brand }}
            </span>
        </td>
        <td class="part">
            <span v-if="isPreview || (isOe && part.length === 1)">{{
                isOe
                    ? selectedPart.name
                    : selectedIamPart.name +
                      getAdditionalDescription(selectedIamPart)
            }}</span>
            <template v-else>
                <span v-if="isOe">
                    <v-combobox
                        v-model="selectedPart"
                        :items="part"
                        item-text="name"
                        item-value="partId"
                        :label="
                            $t(
                                'module-budget.main-budget.parts.parts-row.combobox-label',
                            )
                        "
                        class="part-field-clickable"
                        outlined
                        dense
                        hide-details
                        @change="handleChangeCombobox"
                    >
                    </v-combobox>
                </span>
                <span v-else-if="!isOe && isIamWithoutSM">
                    <v-text-field
                        v-if="hasFluidMatch()"
                        :value="
                            selectedIamPart.name +
                            getAdditionalDescription(selectedIamPart)
                        "
                        :label="
                            $t(
                                'module-budget.main-budget.parts.parts-row.select-iam-part-label',
                            )
                        "
                        append-icon="call_made"
                        @click:append="showIamModal = true"
                        outlined
                        readonly
                        dense
                        hide-details
                        @change="handleChangeCombobox"
                    ></v-text-field>
                    <v-text-field
                        v-else
                        v-model="selectedIamPart.name"
                        outlined
                        dense
                        hide-details
                        @change="handleChangeCombobox"
                        :data-cy="`iam-livre-part-${index}`"
                    ></v-text-field>
                </span>
                <span v-else-if="selectedPart.isIam">
                    <v-tooltip v-if="isIamOutOfStock" bottom max-width="240">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                :value="
                                    selectedIamPart.name +
                                    getAdditionalDescription(selectedIamPart)
                                "
                                :label="
                                    $t(
                                        'module-budget.main-budget.parts.parts-row.select-iam-part-label',
                                    )
                                "
                                :placeholder="
                                    $t(
                                        'module-budget.main-budget.parts.parts-row.part-placeholder',
                                    )
                                "
                                append-icon="mdi-arrow-top-right"
                                class="iam-part-out-of-stock part-field-clickable"
                                @click:append="showIamModal = true"
                                outlined
                                readonly
                                dense
                                hide-details
                                @click="showIamModal = true"
                            ></v-text-field>
                        </template>
                        <span>
                            {{
                                $t(
                                    "module-budget.main-budget.parts.parts-row.out-of-stock-field-tooltip",
                                )
                            }}
                        </span>
                    </v-tooltip>
                    <v-text-field
                        v-else
                        :value="
                            selectedIamPart.name +
                            getAdditionalDescription(selectedIamPart)
                        "
                        :label="
                            $t(
                                'module-budget.main-budget.parts.parts-row.select-iam-part-label',
                            )
                        "
                        :placeholder="
                            $t(
                                'module-budget.main-budget.parts.parts-row.part-placeholder',
                            )
                        "
                        append-icon="call_made"
                        class="part-field-clickable"
                        @click:append="showIamModal = true"
                        outlined
                        readonly
                        dense
                        hide-details
                        @click="showIamModal = true"
                    ></v-text-field>
                </span>
            </template>
        </td>
        <td class="iam" v-if="showIamColumn">
            <div class="d-flex flex-row justify-content-center">
                <v-tooltip color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                            <v-switch
                                v-model="selectedPart.isIam"
                                :disabled="disablePartSwitch && !enableSwitch"
                                color="#4CAA5E"
                                hide-details
                                dense
                                @change="switchPartTypeManual"
                            ></v-switch>
                        </div>
                    </template>
                    <span>
                        {{
                            selectedPart.isIam
                                ? $t(
                                      "module-budget.main-budget.parts.span-switch-to-oe",
                                  )
                                : $t(
                                      "module-budget.main-budget.parts.span-switch-to-iam",
                                  )
                        }}
                    </span>
                </v-tooltip>
            </div>
        </td>
        <td class="price d-flex align-center" style="width: 130px">
            <v-btn
                icon
                medium
                @click="resetPrice"
                :style="
                    !isPreview && !hideBackButton() ? '' : 'visibility: hidden'
                "
            >
                <img src="/images/_SVGs/replay.svg" onload="SVGInject(this)" />
            </v-btn>
            <span v-if="isPreview">{{
                selectedPart.isIam
                    ? selectedIamPart.price
                    : selectedPart.price | currency
            }}</span>
            <div v-else style="position: relative">
                <vuetify-money
                    v-if="selectedPart.isIam"
                    v-bind:options="options"
                    v-model="selectedIamPart.price"
                    type="number"
                    :error="
                        checkValuePrice(
                            selectedPart.isIam,
                            selectedIamPart.price,
                            selectedPart.price,
                        )
                    "
                    step="0.1"
                    min="0"
                    :label="
                        $t(
                            'module-budget.main-budget.parts.parts-row.price-label',
                        )
                    "
                    placeholder="0"
                    outlined
                    dense
                    hide-details
                    class="input-number"
                    :data-cy="`iam-livre-price-${index}`"
                />
                <vuetify-money
                    v-if="!selectedPart.isIam"
                    v-bind:options="options"
                    v-model="selectedPart.price"
                    type="number"
                    :error="
                        checkValuePrice(
                            selectedPart.isIam,
                            selectedIamPart.price,
                            selectedPart.price,
                        )
                    "
                    step="0.1"
                    min="0"
                    :label="
                        $t(
                            'module-budget.main-budget.parts.parts-row.price-label',
                        )
                    "
                    placeholder="0"
                    outlined
                    dense
                    hide-details
                    class="input-number"
                    :data-cy="`iam-livre-price-${index}`"
                />
                <div class="icon-alter-price">
                    <template v-if="checkForEditedPriceOnEditedBudget()">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    style="
                                        margin-left: -18px;
                                        font-size: 30px;
                                        margin-bottom: 6px;
                                        margin-right: -10px;
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    color="blue"
                                    >mdi-circle-small</v-icon
                                >
                            </template>
                            <span>{{
                                $t(
                                    "module-budget.main-budget.parts.parts-row.alter-price-label",
                                )
                            }}</span>
                        </v-tooltip>
                    </template>
                </div>
            </div>
        </td>
        <td class="quantity text-center">
            <v-text-field
                v-if="
                    !isOe &&
                    isIamWithoutSM &&
                    !isPreview &&
                    checkIfFluid(selectedPart)
                "
                v-model="selectedQuantity.quantity"
                outlined
                dense
                class="input-number"
                hide-details
                type="number"
                :min="0"
                @change="handleChangeCombobox"
                :data-cy="`iam-livre-quantity-${index}`"
            ></v-text-field>
            <span
                v-else-if="
                    !isOe &&
                    isIamWithoutSM &&
                    !isPreview &&
                    !checkIfFluid(selectedPart)
                "
                :data-cy="`iam-livre-quantity-${index}`"
            >
                {{ selectedQuantity.quantity }}
            </span>
            <span
                v-else-if="
                    isPreview ||
                    selectedPart.isIam ||
                    selectedPart.quantities.length === 1
                "
                >{{ selectedQuantity.quantity }}</span
            >
            <v-combobox
                v-else
                v-model="selectedQuantitySelect"
                :items="selectedPart.quantities"
                item-text="quantity"
                item-value="id"
                :label="
                    $t(
                        'module-budget.main-budget.parts.parts-row.quantity-label',
                    )
                "
                outlined
                dense
                hide-details
            ></v-combobox>
        </td>
        <td class="discount">
            <span v-if="isPreview">{{ selectedPart.discount }}</span>
            <v-text-field
                v-else
                v-model="selectedPart.discount"
                type="number"
                @keypress="onlyNumberRule"
                min="0"
                max="100"
                class="input-number"
                :label="
                    $t(
                        'module-budget.main-budget.parts.parts-row.discount-label',
                    )
                "
                outlined
                dense
                hide-details
                :rules="descMaxRule"
                @change="ruleDescMax(selectedPart.discount)"
                :data-cy="`iam-livre-discount-${index}`"
            ></v-text-field>
        </td>
        <td class="total" :data-cy="`iam-livre-total-${index}`">
            {{
                computedTotalWithoutVAT == 0
                    ? "0,00 €"
                    : computedTotalWithoutVAT | currency
            }}
        </td>
        <td class="actions">
            <div class="d-flex actions-div">
                <div
                    class="edit"
                    @click="$emit('edit-row-clicked-parts', selectedPart)"
                    v-if="String(selectedPart.itemMpId).includes('-111')"
                >
                    <img
                        src="/images/_SVGs/bo/edit_pencil.svg"
                        :alt="
                            $t(
                                'module-budget.main-budget.parts.parts-row.alt-img-edit',
                            )
                        "
                        onload="SVGInject(this)"
                        width="15"
                        height="20"
                        class="circle"
                    />
                </div>
                <div
                    class="delete"
                    @click="$emit('delete-row-clicked-parts', selectedPart)"
                    v-if="String(selectedPart.itemMpId).includes('-111')"
                >
                    <img
                        src="/images/_SVGs/bo/remove.svg"
                        :alt="
                            $t(
                                'module-budget.main-budget.parts.parts-row.alt-img-remove',
                            )
                        "
                        onload="SVGInject(this)"
                        width="15"
                        height="20"
                        class="circle"
                    />
                </div>
                <div
                    class="delete"
                    v-else-if="
                        checkPermissionToRemove() &&
                        String(selectedPart.itemMpId).includes('-998')
                    "
                    @click="$emit('delete-row-clicked-parts', selectedPart)"
                >
                    <img
                        src="/images/_SVGs/bo/remove.svg"
                        :alt="
                            $t(
                                'module-budget.main-budget.parts.parts-row.alt-img-remove',
                            )
                        "
                        onload="SVGInject(this)"
                        width="15"
                        height="20"
                        class="circle"
                    />
                </div>
            </div>
        </td>

        <iam-modal
            :show="showIamModal"
            :iam-parts="selectedPart.iamParts.filter((o) => !o.isIamWithoutSM)"
            :selected-iam-part.sync="selectedIamPart"
            :selectedIamPart="selectedIamPart"
            :isPartsTruncateIamModa="isPartsTruncate"
            @close-modal="onCloseIamModal"
            @add-iam-operation="onAddIamPart"
            @local-selected-iam-part="captureIamLocalChanges"
            @delete-free-iam="onDeleteIamFree"
        ></iam-modal>

        <base-modal
            v-model="modalInfo.show"
            :title="$t('alert')"
            modal-width="560px"
            :persistent="true"
        >
            <template v-slot:modal-body>
                <span>{{ $t("b2b.quotation.maximum-eucon-requests") }}</span>
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn
                        class="primary-button"
                        text
                        @click="modalInfoClose()"
                    >
                        {{ $t("ok") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </tr>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { QuotationServicesGetPriceFromEucon } from "@services/b2b/quotation/QuotationServices.js";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {
        BaseModal,
        IamModal: () => import("@components/b2b/budget/parts/IamModal.vue"),
    },
    props: {
        /**
         * @param part should be an array where each position represents an OE part in this row
         *             inside every OE (and therefore, each array position) should be an Object containing the following:
         *
         * NOTE that the isSelected property is present in every array, to identify which Object in that Array is selected and therefore should be rendered
         *
         * itemMpId: String | Number,
         * name: String,
         * reference: String,
         * price: String | Number,
         * isSelected: Boolean,
         * iamParts: Array // this array, should contain an Object in each position, with the props: itemMpId, isSelected, reference, brand, name, price, quantity
         * quantities: Arrayx // this array, should contain an Object in each position, with props: id, quantity, isSelected
         */
        part: {
            type: Array,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        isPreview: {
            type: Boolean,
        },
        isActiveSM: {
            type: Boolean,
        },
        isPartsTruncate: { type: Boolean, default: false },
        showIamColumn: { type: Boolean, default: false },
        isIamWithoutSM: { type: Boolean, default: false },
        isIam: { type: Boolean, default: false },
    },
    data() {
        return {
            selectedPart: {},
            selectedIamPart: {},
            selectedQuantity: {},
            originalPrice: -1,
            discount: 0,
            showIamModal: false,
            changePriceInput: false,
            options: {
                suffix: "",
                length: 11,
                precision: 2,
            },
            selectedQuantitySelect: 0,
            descMaxRule: [
                (v) =>
                    (v >= 0 && v <= 100) ||
                    this.$t(
                        "module-budget.main-budget.parts.parts-totals.rule-discount-desc",
                    ),
            ],
            modalInfo: {
                show: false,
            },
        };
    },
    computed: {
        ...mapState("budget", {
            computedBudgetSummary: (state) => state.b2b.budgetSummary,
        }),
        isOe() {
            return !this.selectedPart.isIam;
        },
        computedHasIamParts() {
            if (this.selectedPart.iamParts.length > 0) {
                this.$emit("isCheckedIAM");
            }
            return this.selectedPart.iamParts.length > 0;
        },
        computedTotalWithoutVAT() {
            let newQuantity = this.selectedQuantity;
            if (
                this.selectedPart.quantities &&
                !(this.isIamWithoutSM && !this.isOe)
            ) {
                const findSelectedQtd = this.selectedPart.quantities.filter(
                    (el) => el.isSelected,
                );
                if (findSelectedQtd && findSelectedQtd.length > 0) {
                    newQuantity = findSelectedQtd[0];
                }
            }

            const price =
                this.selectedPart.isIam || (!this.isOe && this.isIamWithoutSM)
                    ? this.selectedIamPart.price
                    : this.selectedPart.price;
            if (!price) return 0;

            const priceXquantity = price * newQuantity.quantity;
            return this.calculateFinalRowPrice(priceXquantity);
        },
        enableSwitch() {
            return (
                !this.isIam &&
                !this.isIamWithoutSM &&
                this.checkIfFluid(this.selectedPart) &&
                !this.checkIfIsEcolub() &&
                this.selectedPart.iamParts &&
                this.selectedPart.iamParts.length > 0
            );
        },
        disablePartSwitch() {
            return (
                this.isPreview ||
                (this.isIamWithoutSM &&
                    (this.checkIfIsFreePart() ||
                        this.checkIfIsPackageService() ||
                        this.checkIfIsEcolub())) ||
                (!this.computedHasIamParts && !this.isIamWithoutSM)
            );
        },
        iamAvailabilityClass() {
            if (
                this.isOe ||
                !this.selectedIamPart ||
                !this.selectedIamPart.reference ||
                this.selectedIamPart.freeIamPart
            ) {
                return "";
            }
            return this.$helpers.getStockAvailabilityClass(
                this.selectedIamPart.stockQuantity,
                this.selectedIamPart.quantity,
            );
        },
        iamAvailabilityLabel() {
            switch (this.iamAvailabilityClass) {
                case "radio-success":
                    return this.$t(
                        "module-budget.main-budget.parts.parts-row.availability-in-stock",
                    );
                case "radio-warning":
                    return this.$t(
                        "module-budget.main-budget.parts.parts-row.availability-limited-stock",
                    );
                case "radio-error":
                    return this.$t(
                        "module-budget.main-budget.parts.parts-row.availability-out-of-stock",
                    );
                default:
                    return "";
            }
        },
        isIamOutOfStock() {
            return this.iamAvailabilityClass === "radio-error";
        },
    },
    watch: {
        computedTotalWithoutVAT(newValue, oldValue) {
            this.$emit("total-updated");
            this.commitToStore();
        },
        selectedPart: {
            handler(newValue, oldValue) {
                if (
                    newValue &&
                    newValue.iamParts &&
                    newValue.iamParts.length > 0
                ) {
                    // if(_.isEmpty(this.selectedIamPart)) {
                    this.selectedIamPart = newValue.iamParts.find(
                        (iamPart) => iamPart.isSelected,
                    );
                    // }
                }
                if (newValue) {
                    let changedValue = newValue;
                    changedValue.isSelected = true;
                    if (oldValue) {
                        this.$emit(
                            "change-selected-part-oe",
                            changedValue,
                            oldValue,
                        );
                    }
                    return changedValue;
                }
                return newValue;
            },
            immediate: true,
        },
        selectedQuantitySelect: {
            handler(newValue) {
                if (!this.selectedPart.isIam) {
                    this.selectedPart.quantities.map((el) => {
                        if (el.quantity == newValue.quantity) {
                            el.isSelected = true;
                            this.selectedQuantity = {
                                id: el.id,
                                quantity: newValue.quantity,
                                isSelected: true,
                            };
                        } else {
                            el.isSelected = false;
                            this.selectedQuantity = {
                                id: el.id,
                                quantity: newValue.quantity,
                                isSelected: false,
                            };
                        }
                    });
                }
            },
            immediate: false,
            deep: true,
        },
        part: {
            handler(newValue) {
                if (this.selectedPart.isIam) {
                    this.selectedQuantity = {
                        quantity: this.selectedIamPart.quantity || 1,
                    };
                } else {
                    this.selectedQuantity = newValue[0].quantities.find(
                        (e) => e.isSelected,
                    );
                }
                this.commitToStore();
            },
            immediate: false,
            deep: true,
        },
        selectedQuantity: {
            handler(newValue) {
                if (this.selectedPart.isIam) {
                    this.selectedIamPart.quantity = newValue.quantity;
                }
            },
            immediate: false,
            deep: true,
        },
        selectedIamPart: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            deep: true,
            immediate: true,
        },
        isPartsTruncate: {
            handler(newValue) {
                return newValue;
            },
            immediate: false,
            deep: true,
        },
    },
    methods: {
        modalInfoClose() {
            this.modalInfo.show = false;
        },
        hideBackButton() {
            return this.isIamWithoutSM && this.selectedPart.isIam;
        },
        hasFluidMatch() {
            return (
                this.selectedPart.iamParts.filter((o) => o.isFluidMatch)
                    .length > 0
            );
        },
        getAdditionalDescription(part) {
            let additionalDescription = part.partDescription
                ? ` [${part.partDescription}]`
                : part.aditionalDescription
                  ? ` [${part.aditionalDescription}]`
                  : "";

            return this.checkIfFluid(part) &&
                !this.checkIfIsEcolub() &&
                this.hasFluidMatch()
                ? additionalDescription
                : "";
        },
        async getPriceFromEucon() {
            if (this.isEmptyReference(this.selectedPart.reference)) return;

            this.$store.commit("loadings/setStateLoadingTemplate", true);
            await QuotationServicesGetPriceFromEucon(
                this.selectedPart.reference,
                this.$route.params.id,
            )
                .then((response) => {
                    if (response.data.result) {
                        this.selectedPart.price = response.data.result;
                    }
                })
                .catch((error) => {
                    if (
                        error.response.status ==
                        this.$globals.ERROR_CODES.TOO_MANY_REQUESTS
                    ) {
                        this.modalInfo.title = this.$t(
                            "backoffice.general.warning",
                        );
                        this.modalInfo.redirect = 1;
                        this.modalInfo.message = this.$t(
                            "b2b.promo-engine.view-campaign-error",
                        );
                        this.modalInfo.iconName = "mdi-alert-outline";
                        this.modalInfo.iconColor = "warning";
                        this.modalInfo.show = true;
                    } else {
                        this.$requestStatus.checkRequestStatus(
                            error.response.status,
                            this.$route.name,
                        );
                    }
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false,
                    );
                });
        },
        isEmptyReference(reference) {
            let emptyReference =
                !reference || reference == "" || String(reference) == "0";
            if (emptyReference) {
                this.selectedPart.emptyReference = true;
            }
            return emptyReference;
        },
        checkIfFluid(item) {
            if (
                item.quantities &&
                Number.isInteger(item.quantities[0].quantity)
            ) {
                return !!(item?.isFluid && item.isFluid == true);
            } else {
                return true;
            }
        },
        checkIfIsEcolub() {
            return String(this.selectedPart.itemMpId).includes("-999");
        },
        checkIfIsPackageService() {
            return String(this.selectedPart.workId).includes("-998");
        },
        checkIfIsFreePart() {
            return String(this.selectedPart.itemMpId).includes("-111");
        },
        async handleChangeCombobox() {
            this.commitToStore();
        },
        async switchPartTypeManual(newValue) {
            this.switchPartType(newValue, true);
        },
        async switchPartType(newValue, manual = false) {
            let cloneIam = _.cloneDeep(this.selectedIamPart.price);
            let cloneOe = _.cloneDeep(this.selectedPart.price);

            this.selectedPart.isIam
                ? (cloneOe = this.originalPrice)
                : (cloneIam = this.originalPrice);
            this.originalPrice = newValue ? cloneIam : cloneOe;
            if (this.originalPrice == undefined) {
                this.originalPrice = 0;
            }

            await this.$nextTick();
            this.$emit("iam-switch-changed", newValue);
        },
        resetPrice() {
            if (this.selectedPart.isIam) {
                this.selectedIamPart.price = this.selectedIamPart.priceOriginal;
            } else {
                this.selectedPart.price = this.selectedPart.priceOriginal;
            }
        },
        checkForEditedPriceOnEditedBudget() {
            if (this.$route.name == "budget-summary-edit") {
                const validation = this.selectedPart.isIam
                    ? this.selectedIamPart.price !==
                      this.selectedIamPart.partialPricePart
                    : this.selectedPart.price !==
                      this.selectedPart.priceOriginal;
                return !!validation;
            } else {
                const validation2 = this.selectedPart.isIam
                    ? this.selectedIamPart.price !==
                      this.selectedIamPart.priceOriginal
                    : this.selectedPart.price !==
                      this.selectedPart.priceOriginal;
                return !!validation2;
            }
        },
        commitToStore() {
            const part = this.selectedPart.isIam
                ? this.selectedIamPart
                : this.selectedPart;
            const partRowValues = {
                itemMpId: part.itemMpId,
                reference: part.reference,
                brand: part.brand || null,
                brandId: part.brandId || null,
                name: part.name,
                isIam: this.selectedPart.isIam,
                price: isNaN(part.price) ? 0 : part.price,
                costPrice: isNaN(part.costPrice) ? 0 : part.costPrice,
                quantity: this.selectedQuantity.quantity,
                discount: this.selectedPart.discount,
                totalWithoutVAT: this.$options.filters.currency(
                    this.computedTotalWithoutVAT,
                    true,
                    false,
                ),
                workId: part.workId,
                entityPackageServiceId: part?.entityPackageServiceId
                    ? part.entityPackageServiceId
                    : "",
                partId: part.partId ? part.partId : "",
                apiPartOrder: part.apiPartOrder ? part.apiPartOrder : "",
                aditionalDescription: part.partDescription
                    ? part.partDescription
                    : part.aditionalDescription
                      ? part.aditionalDescription
                      : "",
                entityPackageServiceId: part?.entityPackageServiceId
                    ? part.entityPackageServiceId
                    : "",
                isFluid: this.selectedPart.isIam
                    ? part.isFluidMatch
                    : part.isFluid,
                isEntityPackageService: part.isEntityPackageService
                    ? part.isEntityPackageService
                    : "",
                isFreePart: part.isFreePart ? part.isFreePart : false,
                isEcoTax: part.isEcoTax ? part.isEcoTax : false,
                hasMatchVINOE: part.hasMatchVINOE ? part.hasMatchVINOE : false,
                isFavoriteBrand: part.isFavoriteBrand
                    ? part.isFavoriteBrand
                    : false,
                quotationPartId: part.quotationPartId,
            };
            this.$store.commit("budget/putPartToBudgetSummary", partRowValues);
        },
        calculateFinalRowPrice(priceXquantity) {
            return this.selectedPart.discount > 0
                ? +priceXquantity * (1 - this.selectedPart.discount / 100)
                : +priceXquantity;
        },
        async onAddIamPart() {
            const idItemMp = this.selectedPart.iamParts[0].itemMpId;
            const getQty = this.selectedQuantity.quantity;

            let newIamPart = {
                brand: "",
                brandId: "",
                isSelected: false,
                itemMpId: idItemMp,
                name: "",
                price: 0,
                quantity: getQty ? getQty : 1,
                reference: "",
                freeIamPart: true,
                remove: false,
                stockQuantity: 0,
                costPrice: 0,
                entityPackageServiceId: "",
            };
            this.selectedPart.iamParts.push(newIamPart);

            await this.$nextTick();

            // For Click on Radio Button
            let lastElement = $(".component-budget__part-part--table tr");
            lastElement = lastElement[lastElement.length - 1];
            $(lastElement).ready(function () {
                $(".available input").click();
            });
        },
        async onCloseIamModal() {
            this.showIamModal = false;

            this.selectedPart.iamParts.forEach((element, index) => {
                if (element.freeIamPart) {
                    if (
                        element.brand == "" ||
                        element.brandId == "" ||
                        element.name == "" ||
                        element.reference == "" ||
                        element.price == 0
                    ) {
                        if (element.isSelected) {
                            this.localSelectedIamPart =
                                this.selectedPart.iamParts[0];
                            this.selectedPart.iamParts[0].isSelected = true;
                        }

                        this.selectedPart.iamParts.splice(index);
                    }
                }
            });

            await this.$nextTick();
            this.commitToStore();
        },
        captureIamLocalChanges(newValue) {
            this.selectedIamPart = newValue;

            const indexNew = this.selectedPart.iamParts.findIndex(
                (el) => el.reference == newValue.reference,
            );
            if (indexNew !== -1) {
                this.selectedPart.iamParts.forEach((element, index) => {
                    element.isSelected =
                        element.reference == newValue.reference;
                });

                this.commitToStore();
            }
        },
        checkValuePrice(selectedPart, iam, oe) {
            if (selectedPart) {
                return iam <= 0;
            } else {
                return oe <= 0;
            }
        },
        ruleDescMax(value) {
            if (value > 100) {
                this.selectedPart.discount = 100;
                this.commitToStore();
            } else if (value < 0) {
                this.selectedPart.discount = 0;
                this.commitToStore();
            }
        },
        roundExactMethod(num, places) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + places) + "e-" + places);
            } else {
                let arr = ("" + num).split("e");
                let sig = "";
                if (+arr[1] + places > 0) {
                    sig = "+";
                }
                return +(
                    Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) +
                    "e-" +
                    places
                );
            }
        },
        checkPermissionToRemove() {
            if (String(this.selectedPart.workId).includes("-998")) {
                let findOtherAssocieatedPart = false;
                const findEquals =
                    this.computedBudgetSummary.parts.values.filter(
                        (p) =>
                            p.entityPackageServiceId ==
                            this.selectedPart.entityPackageServiceId,
                    );
                const copy = _.cloneDeep(findEquals);

                const findEquals2 =
                    this.computedBudgetSummary.parts.values.filter(
                        (p) =>
                            String(p.workId) ==
                            String(this.selectedPart.workId),
                    );
                const copy2 = _.cloneDeep(findEquals2);

                if (copy && copy.length > 1) {
                    findOtherAssocieatedPart = true;
                } else if (copy2 && copy2.length > 1) {
                    findOtherAssocieatedPart = true;
                }

                return findOtherAssocieatedPart;
            } else {
                return true;
            }
        },
        async onDeleteIamFree(iam) {
            const lastIndex = this.selectedPart.iamParts.length - 1;
            this.selectedPart.iamParts.splice(lastIndex);
        },
    },
    created() {
        this.selectedPart = this.part.find((part) => part.isSelected);
        if (!this.selectedPart) {
            this.selectedPart = this.part[0];
            this.selectedPart.isSelected = true;
        }
        this.selectedQuantity =
            this.selectedPart.quantities.find(
                (quantity) => quantity.isSelected,
            ) || {};
        this.selectedIamPart =
            this.selectedPart.iamParts.find((iamPart) => iamPart.isSelected) ||
            {};
        if (_.isEmpty(this.selectedIamPart)) {
            if (this.selectedPart && this.selectedPart.iamParts.length > 0) {
                this.selectedPart.iamParts[0].isSelected = true;
                this.selectedIamPart =
                    this.selectedPart.iamParts.find(
                        (iamPart) => iamPart.isSelected,
                    ) || {};
            } else {
                this.selectedIamPart = {};
            }
        } else if (this.selectedPart.isIam) {
            this.selectedQuantity = { quantity: this.selectedIamPart.quantity };
        }

        this.selectedQuantitySelect = this.selectedQuantity;

        if (this.isIamWithoutSM && this.selectedPart.iamParts.length == 0) {
            let newIamPart = _.cloneDeep(this.selectedPart);
            newIamPart.reference = "";
            newIamPart.brand = "";
            newIamPart.price = 0;
            newIamPart.isIamWithoutSM = true;
            newIamPart.quantity = this.selectedQuantity.quantity;
            this.selectedPart.iamParts.push(newIamPart);
        } else if (this.isIamWithoutSM) {
            this.selectedIamPart.quantity = this.selectedQuantity.quantity;
        }

        this.originalPrice = this.selectedPart.priceOriginal;

        this.commitToStore();
    },
    mounted() {
        this.selectedPart.isIam && this.switchPartType(true); // this is forcing the event to be thrown, so that the parent can know it happened. shouldn't be needed though
    },
};
</script>

<style lang="scss" scoped>
@import "../operations/table-style.scss";
</style>

<style lang="scss" scoped>
// CSS only for iam dialog

@import "@sass/_variables.scss";
.component-label-part {
    p {
        margin-bottom: 5px;
    }
}

$col-padding-top-th: 10px;
$col-margin-bottom-th: 20px;
$col-description-padding-right: 15px;

$col-available-width: 50px;
$col-referencia-width: 150px;
$col-brand-width: 150px;
$col-description-width: auto;
$col-total-width: 120px;

$col-th-td-total-text-align: right;

.component-budget__part-part--modal-title {
    display: flex;
    justify-content: space-between;
}

.component-budget__part-part--table {
    margin-top: 10px;
    width: 100%;

    .mdc-form-field {
        margin-left: -10px;
    }

    .tr__registers {
        &:last-child {
            td {
                padding-bottom: 0;
            }
        }
    }

    th,
    td {
        vertical-align: text-top;

        &.available {
            min-width: $col-available-width;
            width: $col-available-width;
        }
        &.referencia {
            min-width: $col-referencia-width;
            width: $col-referencia-width;
        }
        &.brand {
            min-width: $col-brand-width;
            width: $col-brand-width;
        }
        &.description {
            min-width: $col-description-width;
            width: $col-description-width;
        }
        &.total {
            min-width: $col-total-width !important;
            width: $col-total-width !important;
            text-align: $col-th-td-total-text-align;
        }
        &.actions {
            min-width: 30px !important;
            display: flex !important;
            justify-content: center;
            align-content: center;
        }
    }

    th {
        font-size: 12px;
        line-height: 1.1em;
        font-weight: 400;
        letter-spacing: 0.24px;
        color: $grey;
        padding-top: $col-padding-top-th;
        padding-bottom: $col-margin-bottom-th;
    }

    td {
        font-size: 14px;
        line-height: 1.1em;
        font-weight: 400;
        color: $grey-dark;
    }
}

.input-without-sm {
    font-size: 14px;
}

::v-deep .iam-part-out-of-stock {
    .v-input__slot fieldset {
        border-color: $red !important;
    }

    .v-input__append-inner .v-icon {
        color: $red !important;
    }
}

::v-deep .part-field-clickable {
    cursor: pointer;

    .v-input__slot,
    .v-input__slot input {
        cursor: pointer;
    }
}

.icon-alter-price {
    position: absolute;
    top: 7px;
    left: 10px;
}

.input-number {
    ::v-deep input {
        text-align: right;
    }
}

.actions {
    min-width: 30px !important;
    display: flex !important;
    justify-content: center;
    align-content: center;
}

.actions-div {
    margin-left: 5px;
    width: 45%;
    min-height: 30px !important;
    justify-content: space-around;
    align-items: center;

    div {
        display: flex;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }
}

::v-deep .delete {
    background-color: #d90b3b34;

    .circle {
        g {
            path {
                fill: #ff4747;
            }
        }
    }
}

::v-deep .edit {
    background-color: var(--v-primary-base);

    .circle {
        g {
            path {
                fill: #fff !important;
            }
        }
    }
}
</style>
